/** A brief, non-blocking introduction to the existing pointer-based controls. */

const STYLE_ID = 'mandalizm-demo-guide-style';
const CSS = `
.mandalizm-demo-guide {
  position: fixed; z-index: 42; left: 50%; bottom: max(24px, env(safe-area-inset-bottom));
  transform: translateX(-50%); box-sizing: border-box; width: min(430px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px); padding: 14px 18px; border-radius: 8px;
  background: rgba(0, 13, 21, 0.9); border: 1px solid rgba(90, 240, 220, 0.4);
  color: #d3faf4; font: 12px/1.65 ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  text-align: center; pointer-events: none;
}
.mandalizm-demo-guide[hidden] { display: none; }
.mandalizm-demo-guide strong { display: block; color: #8dffe4; letter-spacing: 0.12em; }
.mandalizm-demo-guide small { display: block; margin-top: 5px; color: #98bfc4; font-size: 10px; }
@media (max-width: 600px), (max-height: 480px) {
  .mandalizm-demo-guide {
    top: max(12px, env(safe-area-inset-top)); bottom: auto;
    padding: 8px 12px; font-size: 11px;
  }
}
`;

export class DemoGuide {
  readonly element: HTMLDivElement;
  private timeout: number | null = null;
  private readonly dismiss = (): void => this.hide();

  constructor(parent: HTMLElement = document.body) {
    if (document.getElementById(STYLE_ID) === null) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      document.head.appendChild(style);
    }
    this.element = document.createElement('div');
    this.element.className = 'mandalizm-demo-guide';
    this.element.hidden = true;
    this.element.setAttribute('role', 'status');
    const action = document.createElement('strong');
    action.textContent = 'CLICK / TAP THE SEALS';
    const timing = document.createElement('div');
    timing.textContent = 'Time your touch as the rings come together.';
    const hint = document.createElement('small');
    hint.textContent = 'Follow the beat · This guide fades automatically';
    this.element.append(action, timing, hint);
    parent.appendChild(this.element);
  }

  show(): void {
    this.hide();
    this.element.hidden = false;
    // The original PLAY DEMO pointerdown already occurred before show(). These
    // listeners dismiss on the next input without consuming the gameplay tap.
    window.addEventListener('pointerdown', this.dismiss);
    window.addEventListener('keydown', this.dismiss);
    this.timeout = window.setTimeout(this.dismiss, 4_000);
  }

  hide(): void {
    this.element.hidden = true;
    if (this.timeout !== null) window.clearTimeout(this.timeout);
    this.timeout = null;
    window.removeEventListener('pointerdown', this.dismiss);
    window.removeEventListener('keydown', this.dismiss);
  }

  dispose(): void {
    this.hide();
    this.element.remove();
  }
}
